import { styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { LayoutColors } from '@src/core/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${uni('scale-400')};
  width: 100%;
  padding: ${uni('padding-content')};
  border-radius: ${uni('border-radius-md')};
  border: 1px solid ${uni('border-static-content-default')};
  background-color: ${uni('bg-static-content-default')};

  ${tabletBreakpoint} {
    border-radius: ${uni('border-radius-sm')};
  }
`;

export const SpinnerWrapper = styled('div')`
  width: 100px;
  height: 100px;
`;

export const Message = styled('div')`
  text-align: center;
  color: ${LayoutColors.blackMain};
`;
